<template>
    <base-modal :visible="true" min-height="45rem" @close="close" title="Advanced search">
        <base-input v-model="form.name_contains" name="name_contains" label="Title contains"/>

        <base-input
            v-model="form.content_contains"
            name="content_contains"
            label="Content contains"/>

        <label>Topics</label>
        <multiselect
            v-model="form.topics"
            :options="Array.isArray(topics_list.data) ? topics_list.data : []"
            :internal-search="true"
            placeholder="Select topics"
            :multiple="true"
            track-by="id"
            label="name"
            name="topics"/><br/>

        <label>
            Tags &nbsp;
            <input type="radio" name="or_tag" :value="false" v-model="form.or_tags"/> and &nbsp;
            <input type="radio" name="or_tag" :value="true" v-model="form.or_tags"/> or &nbsp;
        </label>

        <multiselect
            v-model="form.tags"
            :options="tags_list.data.results || []"
            :internal-search="false"
            :loading="tags_list.loading"
            :multiple="true"
            placeholder="Search tag to select"
            @search-change="load_tags"
            track-by="id"
            label="name"
            name="tags"/><br/>

        <label>Authors</label>
        <multiselect
            v-model="form.authors"
            :options="participants.data.results || []"
            placeholder="Search user to select"
            :loading="participants.loading"
            @search-change="load_participants"
            open-direction="top"
            :custom-label="full_name"
            select-label=""
            :multiple="true"
            track-by="id"
            name="user"/><br/>

        <base-button @click="search" class="is-primary" icon="fas fa-search" text="Search"/>&nbsp;

        <base-input
            v-model="form.name"
            name="title"
            validate="required"
            label="Filter Name"
            validate_on="change"/>

        <base-button
            @click="save"
            class="is-info"
            icon="fas fa-save"
            text="Save Filter"
            :loading="create_search.loading || update_search.loading"/>

    </base-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';
import { copy } from '../../utils/helpers';

const init_form = {
    name: '',
    content_contains: '',
    name_contains: '',
    or_tags: false,
    authors: [],
    topics: [],
    tags: [],
};

export default {
    name: 'SavedSearchModal',
    components: { Multiselect },
    props: ['space', 'visible', 'saved_search'],
    data() {
        return {
            form: copy(init_form),
            loaded: false,
        };
    },
    computed: {
        ...mapState('tags', { tags_list: 'list' }),
        ...mapState('user', { users_list: 'list' }),
        ...mapState('topics', { topics_list: 'list' }),
        ...mapState('spaces', ['participants']),
        ...mapState('saved_searches', { create_search: 'create', update_search: 'update' }),
    },
    watch: {
        visible(val) {
            if (!val || this.loaded) return;
            this.load_tags();
            this.load_participants();
            this.loaded = true;
        },
        saved_search: {
            immediate: true,
            handler(saved_search) {
                this.form = saved_search || copy(init_form);
            },
        },
    },
    methods: {
        full_name({ first_name, last_name }) {
            return `${first_name} ${last_name}`;
        },
        load_tags(search = '') {
            this.$store.dispatch('tags/list', { space_id: this.space.id, search });
        },
        load_participants(search = '') {
            this.$store.dispatch('spaces/participants', { space_id: this.space.id, search });
        },
        search() {
            const query = {
                name_contains: this.form.name_contains,
                content_contains: this.form.content_contains,
                authors: this.form.authors.map(obj => obj.id),
                topics: this.form.topics.map(obj => obj.id),
                tags: this.form.tags.map(obj => obj.id),
                search: null,
            };
            this.$router.push({ name: 'content', params: this.$route.params, query });
            this.$emit('close');
            this.$emit('reload');
        },
        save() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.store().then(() => {
                    this.$emit('close');
                    this.$store.dispatch('saved_searches/list', { space_id: this.space.id });
                });
            });
        },
        store() {
            const data = {
                ...this.form,
                tags: this.form.tags.map(obj => obj.id),
                topics: this.form.topics.map(obj => obj.id),
                authors: this.form.authors.map(obj => obj.id),
            };

            if (!this.saved_search) {
                // Create
                return this.$store.dispatch('saved_searches/create', {
                    space_id: this.space.id,
                    data,
                });
            }

            // Update
            return this.$store.dispatch('saved_searches/update', {
                space_id: this.space.id,
                saved_search_id: this.saved_search.id,
                data,
            });
        },
        close() {
            this.form = copy(init_form);
            this.$emit('close');
        },
    },
};
</script>
